export type StatusResponse = {
  app_name: string;
  environment: string;
  demo_data: boolean;
  live_allowed: boolean;
  execution_mode: "paper" | "live";
  live_preflight: Array<{ name: string; ok: boolean; detail: string }>;
};

export type DashboardResponse = {
  system_health: string;
  execution_mode: string;
  open_exposure: number;
  total_pnl: number;
  active_markets_tracked: number;
  latest_weather_points: number;
  top_signals: SignalRecord[];
  recent_orders: OrderRecord[];
  alerts: Array<{ id: string; severity: string; code: string; message: string }>;
  positions: PositionRecord[];
};

export type MarketRecord = {
  id: string;
  market_id: string;
  question: string;
  location_name?: string | null;
  category?: string | null;
  status: string;
  liquidity?: number | null;
  volume?: number | null;
  best_bid?: number | null;
  best_ask?: number | null;
  last_price?: number | null;
  tick_size?: string | null;
};

export type MappingRecord = {
  id: string;
  strategy_id: string;
  market_id: string;
  station_id: string;
  mapping_confidence: number;
  approval_status: string;
  location_name?: string | null;
  source_record_json?: Record<string, unknown> | null;
};

export type WeatherRecord = {
  id: string;
  station_id: string;
  dataset: string;
  observed_at?: string | null;
  temperature_c?: number | null;
  visibility_sm?: number | null;
  flight_category?: string | null;
  summary?: string | null;
  normalized_json?: Record<string, unknown> | null;
  lat?: number;
  lng?: number;
  latitude?: number;
  longitude?: number;
};

export type SignalRecord = {
  id: string;
  strategy_id: string;
  mapping_id: string;
  market_id: string;
  station_id: string;
  token_id: string;
  side: string;
  score: number;
  confidence: number;
  rationale: string;
  why_json?: Record<string, unknown> | null;
  created_at?: string;
};

export type OrderRecord = {
  id: string;
  trade_intent_id: string;
  broker_order_id?: string | null;
  client_order_id?: string | null;
  event_type: string;
  mode: string;
  status: string;
  event_time?: string | null;
};

export type PositionRecord = {
  id: string;
  market_id: string;
  token_id: string;
  quantity: number;
  avg_entry_price: number;
  mark_price: number;
  realized_pnl: number;
  unrealized_pnl: number;
};

export type RiskResponse = {
  limits: Record<string, number>;
  live_allowed: boolean;
  positions: PositionRecord[];
  latest_order?: OrderRecord | null;
};

export type ReplayReport = {
  mode: string;
  strategy_id: string;
  signals_generated: number;
  signals: Array<Record<string, unknown>>;
};

export type WorkspaceRole = "demo" | "paid" | "admin";

export type AuthSource = "public-demo" | "stripe" | "local-preview" | "admin";

export type AuthSession = {
  role: WorkspaceRole;
  email: string;
  source: AuthSource;
  issued_at: string;
  expires_at?: string;
};

export const BURRARD_AUTH_STORAGE_KEY = "burrarddesk-auth-session";
export const BURRARD_POLYMARKET_HOME_URL = "https://polymarket.com";
export const BURRARD_POLYMARKET_MARKETS_URL = "https://polymarket.com/markets";
export const BURRARD_POLYMARKET_PORTFOLIO_URL = "https://polymarket.com/portfolio";

export function createAuthSession(role: WorkspaceRole, source: AuthSource, email: string): AuthSession {
  return {
    role,
    source,
    email,
    issued_at: new Date().toISOString(),
  };
}
